import React from 'react';
import { RightOutlined } from '@ant-design/icons';
import { Row, Col } from 'antd';
import { StyledTitle as Title } from '../../fields/Title';
import PhoneImage from '../../../assets/phone.gif';
import { StyledButton } from '../../../styles/StyledComponents';
import { FormattedMessage } from 'react-intl';

export const StudentsWhy = () => {
  return (
    <>
      <Row justify='center'>
        <Col
          xl={20}
          sm={22}
          style={{
            background: '#fff',
            padding: 40,
            boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)'
          }}
        >
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 40 }}>
            {/* LEFT COLUMN */}
            <Col xl={12}>
              <img src={PhoneImage} style={{ height: 400, margin: '0 auto', display: 'block' }} alt='' />
            </Col>
            {/* RIGHT COLUMN */}
            <Col xl={12}>
              <Title level={2} style={{ color: '#333', fontWeight: 'bolder' }}>
                <FormattedMessage id='why-tutorD.title' />
              </Title>
              <br />
              <strong style={{ color: '#333' }}>
                <FormattedMessage id='why-tutorD.subTitle' />
              </strong>
              <br />
              <br />
              <p>
                <FormattedMessage id='students-header.main.description' />
              </p>
              <br />
              <StyledButton style={{ borderRadius: 6, height: 40, width: 150 }}>
                <FormattedMessage id='why-tutorD.about-us-link' /> <RightOutlined />
              </StyledButton>
            </Col>
          </Row>
          {/* PURPLE CONTAINER */}
          {/* <Row justify="center" style={{margin: '40px 0'}}>
            <Col
              xl={24}
              style={{
                background: '#8053D7',
                borderRadius: 6,
                filter: 'drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25))',
                padding: 40,
              }}
            >
              <p
                style={{
                  fontSize: '2.5em',
                  fontFamily: 'Montserrat Bold',
                  color: '#fff',
                  textAlign: 'center',
                }}
              >
                Allowing you to address the{' '}
                <span style={{color: '#FFDC54'}}>Whole Student.</span>
              </p>
              <p style={{color: '#fff', textAlign: 'center'}}>
                Students self identifying their learning language can provide
                educators with the information to make for a more engaging
                experience. We also have to
              </p>
            </Col>
          </Row> */}
        </Col>
      </Row>
    </>
  );
};
